<script>
import { required, maxLength, requiredUnless } from 'vuelidate/lib/validators';
const englishLang = (value) => {
    const regex = new RegExp("^[a-zA-Z0-9 ]+$")
    if (regex.test(value)) {
        return true;
    } else {
        return false;
    }
}
const isCodeOrg = (value) => {
    if (value.includes("studio.code.org/projects/applab/")) {
        return true;
    } else {
        return false;
    }
}
const RequestCall = () => import('@/components/requestCall');
import Multiselect from 'vue-multiselect'
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
    name: 'Modal',
    components: { 
        Multiselect,
        RequestCall
    },
    mounted() {
        axios.get(BASE_URL + "/products/category/product")
        .then(({ data }) => {
            for (let item of data.data) {
                this.kits.push({
                    name: item.product_name,
                    code: item.product_code,
                    src: item.image
                })
            }
                this.kits.push({
                    name:'Code.org',
                    code:'codeOrg',
                    src:'https://images.avishkaar.cc/misc/projects/code-org.png'
           })

                    this.kits.push({
                    name:'MIT',
                    code:'MIT',
                    src:'https://images.avishkaar.cc/misc/projects/MIT.png'
           })
        });
        axios.get(BASE_URL + "/schools/getZohoSchools")
        .then(({ data }) => {
            // To sort it alphabetically
            let schoolData = data.data.sort((a, b) => a.school_name.localeCompare(b.school_name));
            for (let item of schoolData) {
                this.schools.push({
                    schoolId: item.school_id,
                    schoolName: item.school_name,
                })
            }
            if (this.$cookies.get('userAccess')) {
                axios.get(BASE_URL + "/auth/user")
                .then(({ data }) => {
                    if(this.schools.filter((a)=>data.user.school_id == a.schoolId).length != 0) {
                        this.isSchool = true;
                        this.details.school = this.schools.filter((a)=>data.user.school_id == a.schoolId )[0];
                    }
                    axios.get(BASE_URL + `/programs/user/${data.user.user_id}`)
                    .then((program) => {
                        this.programs = program.data.data.programs.created;
                    })
                });
            };
        });
        axios.get(BASE_URL + "/users/allUsername")
        .then(({ data }) => {
            for (let item of data.data) {
                if(item.username != null) {
                    this.usernames.push({
                        user_id: item.user_id,
                        username: item.username,
                    })
                }
            }
        });
    },
    validations: {
        uploads: {
            files: {
                requiredIf: requiredUnless(function() { return this.uploads.youtube_link != "" }),
            },
            thumbnail: {
                required,
            },
            youtube_link: {
                requiredIf: requiredUnless(function() { return this.uploads.files != "" }),
            }
        },
        details: {
            title: {
                required,
                maxLength: maxLength(50),
                englishLang
            },
            description: {
                required,
                maxLength: maxLength(700)
            },
            school: { required },
            program: {}
        },
        additional_details: {
            collabrators: {},
            kits: {
                required
            },
            tags: {
                
            },
        },
        codeOrg:{
            isCodeOrg,
            required
        }
    },
    data() {
        return {
            processing: false,
            requestCallHead: null,
            step: 1,
            images: [],
            videos: [],
            thumbnail_preview: null,
            uploads: {
                files: [],
                thumbnail: null,
                youtube_link: null,
            },
            details: {
                title: null,
                description: null,
                school: null,
                program: null
            },
            additional_details: {
                collabrators: [],
                kits: [],
                tags: [],
            },
            kits: [],
            schools: [],
            isSchool: false,
            programs: null,
            usernames: [],
            selected: null,
            link_added: false,
            codeOrg: null,
            MIT: null
        }
    },
    computed: {
        btnDisabled() {
            if (this.step === 1) {
                return this.$v.uploads.$invalid
            } else if (this.step === 2) {
                return this.$v.details.$invalid
            } else if (this.step === 3) {
                return this.$v.additional_details.$invalid
            }
        },
        stepTitle() {
            if (this.step === 1) return "Choose Project Files";
            else if(this.step === 2) return "Add Project Details";
            else return "Add Additional Details";
        }
    },
    methods: {
        thumbnailRemove() {
            this.thumbnail_preview = null;
            this.uploads.thumbnail = null;
        },
        removeImg(item, index) {
            this.images.splice(index, 1);
            for (let i = 0; i<this.uploads.files.length; i++) {
                if (this.uploads.files[i].name === item.name) {
                    this.uploads.files.splice(i, 1);
                }
            }
        },
        showRequestCall(head){
                this.requestCallHead = head
                this.$root.$emit('bv::show::modal', 'requestCallModal', '#btnShow')
            },
        removeVideo(item, index) {
            this.videos.splice(index, 1);
            for (let i = 0; i<this.uploads.files.length; i++) {
                if (this.uploads.files[i].name === item.name) {
                    this.uploads.files.splice(i, 1);
                }
            }
        },
        close() {
            this.$emit('close');
        },
        addTag (newTag) {
            const tag = {
                schoolId: newTag,
                schoolName: newTag,
            }
            this.schools.push(tag);
            this.details.school = tag;
        },
        postData() {
            this.processing = true;
            let collabrators = ""
            let kitsUsed = ""
            let tags = ""
            let program = null
            for (let item of this.additional_details.collabrators) {
                collabrators =  collabrators + item.username + ","
            }

            for (let item of this.additional_details.kits) {
                kitsUsed = kitsUsed + item.code + ","
            }

            for (let item of this.additional_details.tags) {
                tags = tags + item + ","
            }

            
            collabrators = collabrators.replace(/,\s*$/, "");
            kitsUsed = kitsUsed.replace(/,\s*$/, "");
            tags = tags.replace(/,\s*$/, "");

            // let schoolName = ""
            // let schoolId = ""
            // if(isNaN(this.details.school.schoolId)) { schoolName = this.details.school.schoolId }
            // else { schoolId = this.details.school.schoolId }

            let youtube_link = ""
            if (this.uploads.youtube_link != '') {youtube_link = this.uploads.youtube_link}
            if(this.additional_details.kits.filter(a=>a.code.includes('MIT')).length) {} else {this.MIT = null}
            if(this.additional_details.kits.filter(a=>a.code.includes('codeOrg')).length) {} else {this.codeOrg = null}
            if(this.details.program) { program = this.details.program.file_name + '#split#' + this.details.program.program_id }
            const payload = {
                title: this.details.title,
                description: this.details.description,
                schoolId: this.details.school.schoolId,
                youtube_link,
                // schoolName,
                collabrators,
                kitsUsed,
                tags,
                third_party: this.codeOrg,
                projectCodes: program,
            }
            return axios.post(BASE_URL + "/projects", payload)
            .then( async ({ data }) => {
                let counter = 0;
                let body = new FormData;
                body.append("fileUpload", this.uploads.thumbnail)
                body.append("projectUri", data.data.projectUri)
                axios.put(BASE_URL + "/projects/thumbnail", body)
                .then(({data: response}) => {
                  console.log(response);
                  if(this.uploads.files != ''){
                    for (let item of this.uploads.files) {
                    let formData = new FormData;
                    formData.append("fileUpload", item)
                    formData.append("projectUri", data.data.projectUri)
                    axios.post(BASE_URL + "/projects/uploads", formData)
                    .then(({ data: response }) => {
                        console.log(response);
                        counter += 1
                        console.log({counter});
                        console.log(this.uploads.files.length);
                        if (counter === this.uploads.files.length) {
                            if(this.MIT){
                            let MITbody = new FormData;
                            MITbody.append("fileUpload", this.MIT)
                            MITbody.append("projectUri", data.data.projectUri)
                            axios.put(BASE_URL + "/projects/MIT", MITbody)
                               .then(({data: response}) => {
                                this.close();
                                this.processing = false
                                this.$bvModal.show('success-project-upload')
                            })
                            }else{
                            this.close();
                            this.processing = false
                            this.$bvModal.show('success-project-upload')
                            }
                        }
                    })
                    .catch(e => {
                        alert("Unsupported File Types only .jpg .png .jpeg and .mp4 are supported")
                        this.processing = false
                    })
                  }} else {
                      this.close();
                      this.processing = false;
                      this.$bvModal.show('success-project-upload');
                      }
                })
                .catch(error => {
                    alert("Unsupported File Types only .jpg .png .jpeg and .mp4 are supported");
                    this.processing = false;
                })
            })
            .catch(error => {
                alert("Something Went Wrong")
                this.processing = false
            })
        },
        async next() {
            if (this.step === 1) {
                this.$v.uploads.$touch();
                if(!this.$v.uploads.$invalid) {
                    this.step += 1;
                }
            } else if (this.step === 2) {
                this.$v.details.$touch();
                if (!this.$v.details.$invalid) {
                    this.step += 1;
                }
            } else if (this.step === 3) {
                
                this.$v.additional_details.$touch();
                if (!this.$v.additional_details.$invalid) {
                    await this.postData();
                }
            }

            // if(this.step !== 3) {
            //     this.step += 1;
            // } else {
                
            // }
        },
        back() {
            if (this.step === 1) {
                this.close()
            } else {
                this.step -= 1;
            }
        },
        uploadThumbnail(event) {
            const file = event.target.files[0];
            event.target.value = null;
            if (file.name.includes(".jfif")) {
                alert("Unsupported File Types only .jpg .png and .jpeg are supported")
                return;
            }
            else if (file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png") {
                this.uploads.thumbnail = file
                let reader = new FileReader()
                reader.onload = (e) => {
                    this.thumbnail_preview = e.target.result;
                }
                reader.readAsDataURL(file);
            } else {
                alert("Unsupported File Types only .jpg .png and .jpeg are supported")
                return;
            }
        },
        uploadAia(event) {
            const file = event.target.files[0];
            if (!file.name.includes(".aia")) {
                alert("Unsupported File Types only .aia are supported")
                return;
            }else {
                this.MIT = file
            }
        },
        uploadFiles(e) {
            this.uploads.files = [...this.uploads.files, ...e.target.files];
            e.target.value = null
            this.images = []
            this.videos = []
            for (let item of this.uploads.files) {
                if (item.type === "image/jpg" || item.type === "image/jpeg" || item.type === "image/png" || item.type === "video/mp4") {
                    let reader = new FileReader()
                    if (/image\/.*/.test(item.type)) {
                        reader.onload = (e) => {
                            this.images.push({
                                img: e.target.result,
                                name: item.name
                            });
                        }
                        reader.readAsDataURL(item);
                    } else if (/video\/.*/.test(item.type)) {
                        let fileUrl = URL.createObjectURL(item)
                        this.videos.push({
                            video: fileUrl,
                            name: item.name
                        })
                    }
                } else {
                    this.uploads.files = []
                    alert("Unsupported File Types only .jpg .png .jpeg and .mp4 are supported")
                    return
                }
            }
        },
    },
};
</script>

<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <b-form @submit.prevent="next">
                <div class="modal"
                    role="dialog"
                    aria-labelledby="modalTitle"
                    aria-describedby="modalDescription">
                    <div class="custom-modal-header" id="modalTitle">
                        <div>
                            {{ stepTitle }}
                        </div>
                        <div class="progress-bar-desktop">
                            <ul class="progressbar">
                                <li :class="{active: uploads.files.length !== 0 && uploads.thumbnail !== null}"></li>
                                <li :class="{active: step > 2}"></li>
                                <li :class="{active: step > 3}"></li>
                            </ul>
                        </div>
                        <div>
                            <button
                                type="button"
                                class="btn-close"
                                @click="close"
                                aria-label="Close modal">
                                x
                            </button>
                        </div>
                    </div>

                    <section class="modal-body scrollbar-primary" id="modalDescription">
                        <div class="progress-bar-mobile">
                            <b-row style="border-bottom: 1px solid #eeeeee; margin-top: 1rem">
                                <b-col cols="8" offset="2">
                                    <ul class="progressbar">
                                        <li :class="{active: uploads.files.length !== 0 && uploads.thumbnail !== null}"></li>
                                        <li :class="{active: step > 2}"></li>
                                        <li :class="{active: step > 3}"></li>
                                    </ul>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row no-gutters v-if="step === 1" class="d-block d-md-none" style="padding: 15px;">
                            <b-col cols="12">
                                <div style="font-family:Poppins;font-weight:500;font-size:1.125rem">Upload Images / Videos Files Or Your Project Youtube Video</div>
                                <b-form-input size="lg" class="my-3" placeholder="Youtube Video Link" v-model="uploads.youtube_link" autofocus></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row v-if="step === 1" style="margin: 0; border-bottom: 1px solid #eeeeee">
                            <b-col lg="4" class="mb-4 mb-lg-0" style="padding: 15px; background-color: rgb(223,113,27,0.05)">
                                <div>
                                <div v-if="thumbnail_preview === null">
                                    <input
                                        class="d-none"
                                        type="file"
                                        ref="thumbnail_upload"
                                        accept="image/jpeg, image/png, image/jpg"
                                        @change="uploadThumbnail">
                                    <label @click="$refs.thumbnail_upload.click()" class="upload-thumbnail-label" >
                                        <div class="label-text">
                                            <div><b-icon icon="plus"></b-icon> Add Thumbnail</div>
                                        </div> 
                                    </label>
                                </div>
                                <div v-else class="row">
                                    <div class="">
                                        <div class="card position-relative deleteButton">
                                            <img :src="thumbnail_preview" alt="" class="card-img-top" style="min-height:20vh">
                                            <div class="upload-overlay deleteButtonIcon" @click="thumbnailRemove">
                                                <b-icon icon="trash" class="trash-icon" variant="light"></b-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </b-col>
                            <b-col lg="8"  style="padding: 15px">
                              <div>
                                <b-row no-gutters class="d-none d-md-block">
                                    <b-col cols="12">
                                        <div style="font-family:Poppins;font-weight:500;font-size:1.125rem">Upload Images / Videos Files Or Your Project Youtube Video</div>
                                        <b-form-input size="lg" class="my-3" placeholder="Youtube Video Link" v-model="uploads.youtube_link" autofocus></b-form-input>
                                    </b-col>
                                </b-row>
                                <div v-if="images.length === 0 && videos.length === 0">
                                    <input 
                                        class="d-none"
                                        type="file"
                                        ref="project_upload"
                                        accept="image/jpeg, image/png, image/jpg, video/mp4"
                                        multiple
                                        @change="uploadFiles">
                                    <label @click="$refs.project_upload.click()" style="border: 2px dashed #7d7d7d;height: 35vh;">
                                        <div class="label-text">
                                            <div><b-icon icon="upload"></b-icon> Upload Files</div>
                                            <br>
                                            <b-row style="margin: 0; justify-content: center;">
                                                <b-col cols="3" style="padding: 0">Video</b-col>
                                                <b-col cols="3" style="padding: 0">Image</b-col>
                                            </b-row>
                                        </div> 
                                    </label>
                                </div>
                                <b-row v-else style="min-height: 50vh" no-gutters>
                                    <b-col cols="12">
                                        <b-row no-gutters>
                                            <b-col cols="12">
                                                <input 
                                                    class="d-none"
                                                    type="file"
                                                    ref="project_upload"
                                                    accept="image/jpeg, image/png, image/jpg, video/mp4"
                                                    multiple
                                                    @change="uploadFiles">
                                                <label @click="$refs.project_upload.click()" class="add-more" style="border: 2px dashed #7d7d7d;">
                                                    <div class="label-text">
                                                        <div><b-icon icon="upload"></b-icon> Add More</div>
                                                    </div> 
                                                </label>
                                            </b-col>
                                            <!-- <b-col cols="12" v-if="link_added">
                                                <div class="embed-responsive embed-responsive-16by9 deleteButton">
                                                    <iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + uploads.youtube_link.split('v=')[1]"></iframe>
                                                    <div class="upload-overlay deleteButtonIcon" @click="link_added=false;uploads.youtube_link=null">
                                                        <b-icon icon="trash" class="trash-icon" variant="light"></b-icon>
                                                    </div>
                                                </div>
                                            </b-col> -->
                                            <div class="col-lg-6 mt-n3" v-for="(item, i) in videos" :key="i">
                                                <div class="card mb-3 deleteButton">
                                                    <video width="100%" controls style="max-height: 25vh">
                                                        <source :src="item.video">
                                                    </video>
                                                    <div class="upload-overlay deleteButtonIcon" @click="removeVideo(item, i)">
                                                        <b-icon icon="trash" class="trash-icon" variant="light"></b-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-row>
                                        <div class="card-columns">
                                            <div class="card position-relative deleteButton" v-for="(item,index) in images" :key="index">
                                                <img :src="item.img" :alt="'img' + index" class="card-img-top">
                                                <div class="upload-overlay deleteButtonIcon" @click="removeImg(item, index)">
                                                    <b-icon icon="trash" class="trash-icon" variant="light"></b-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                              </div>
                            </b-col>
                        </b-row>
                        <b-row v-else-if="step > 1" class="mt-3">
                            <b-col style="padding: 0 20px">
                                <div v-if="step === 2">
                                    <b-form-group label="Title" class="text-left">
                                        <b-form-input @blur="$v.details.title.$touch()" lang="en" v-model.trim="$v.details.title.$model"></b-form-input>
                                        <div class="text-danger" v-if="$v.details.title.$error">
                                            <small v-if="!$v.details.title.required">
                                                * Required Field
                                            </small>
                                            <small v-else-if="!$v.details.title.englishLang">
                                                * Only English Characters, Numbers and spaces are allowed
                                            </small>
                                            <small v-else-if="!$v.details.title.maxLength">
                                                * Max Length 50 characters
                                            </small>
                                        </div>
                                    </b-form-group>
                                    <b-form-group label="Description" class="text-left">
                                        <b-form-textarea @blur="$v.details.description.$touch()" rows="5" v-model.trim="$v.details.description.$model"></b-form-textarea>
                                        <div class="text-danger" v-if="$v.details.description.$error">
                                            <small v-if="!$v.details.description.required">
                                                * Required Field
                                            </small>
                                            <small v-else-if="!$v.details.description.maxLength">
                                                * Max Length 700 characters
                                            </small>
                                        </div>
                                    </b-form-group>
                                    <b-form-group label="School Name" class="text-left" v-if="isSchool">
                                        <b-form-input v-model="details.school.schoolName" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="School Name" class="text-left" v-else>
                                        <multiselect 
                                            v-model="details.school"
                                            placeholder="Please Select your School"
                                            label="schoolName"
                                            track-by="schoolId"
                                            :options="schools"
                                            :option-height="104">
                                            <!-- :preserve-search="true"
                                            tag-placeholder="Press Enter To Add School"
                                            :taggable="true"
                                            @tag="addTag" -->
                                        </multiselect>
                                        <div class="text-danger" v-if="$v.details.school.$error">
                                            <small v-if="!$v.details.school.required">
                                                * Required Field
                                            </small>
                                        </div>
                                        <RequestCall :head="requestCallHead"/>
                                        <small style="margin:0.5rem 0.5rem 0 0;font-family:Roboto">Didn't find your School?</small>
                                        <small style="cursor:pointer;color:#DF711B;font-weight:500;font-family:Roboto" @click="showRequestCall('Didnt found school in list!')">Contact Us</small>
                                    </b-form-group>
                                </div>
                                <div v-else-if="step === 3">
                                    <b-form-group label="Code" class="text-left" v-if="programs ? (programs.length ? true : false) : false">
                                        <multiselect 
                                            v-model="details.program"
                                            placeholder="Please Select your Program"
                                            label="file_name"
                                            track-by="program_id"
                                            :options="programs"
                                            :option-height="104">
                                        </multiselect>
                                        <small style="margin:0.5rem 0.5rem 0 0;font-family:Roboto" v-if="details.program"><a style="color: #007bff;" target="_blank" :href="`https://www.avishkaar.cc/ams_web/amsReact/api/share.php?id=${details.program.program_id}`">{{details.program.file_name}}</a></small>
                                    </b-form-group>
                                    <b-form-group label="Collabrators" class="text-left">
                                        <multiselect 
                                            v-model="$v.additional_details.collabrators.$model"
                                            placeholder="Add User"
                                            label="username"
                                            track-by="user_id"
                                            :options="usernames"
                                            :multiple="true">
                                        </multiselect>
                                        <div class="text-danger" v-if="$v.additional_details.collabrators.$error">
                                            <small v-if="!$v.additional_details.collabrators.required">
                                                * Required Field
                                            </small>
                                        </div>
                                    </b-form-group>
                                    <b-form-group label="Avishkaar Kit Used" class="text-left">
                                        <multiselect 
                                            v-model="$v.additional_details.kits.$model"
                                            placeholder="Add Avishkaar Kit"
                                            label="name"
                                            track-by="name"
                                            selectLabel=""
                                            deselectLabel=""
                                            selectedLabel=""
                                            :options="kits"
                                            :option-height="104" 
                                            :multiple="true">
                                            <template slot="option" slot-scope="props">
                                                <div class="d-flex">
                                                    <div class="option__desc"><small class="option__title">{{ props.option.name }}</small></div>
                                                    <div class="ml-auto">
                                                        <img class="option__image" :src="props.option.src" :alt="props.option.name" height="50px" width="50px">
                                                    </div>
                                                </div>
                                            </template>
                                        </multiselect>
                                        <div class="text-danger" v-if="$v.additional_details.kits.$error">
                                            <small v-if="!$v.additional_details.kits.required">
                                                * Required Field
                                            </small>
                                        </div>
                                        <div class="text-danger" v-if="additional_details.kits.length > 1 && (additional_details.kits.filter(a=>a.code.includes('codeOrg')).length || additional_details.kits.filter(a=>a.code.includes('MIT')).length)">
                                            <small>
                                                * Please don't select multiple if you are selecting MIT or Code.org
                                            </small>
                                        </div>
                                    </b-form-group>
                                    <b-form-group label="Hashtags (Optional)" class="text-left">
                                        <b-form-tags input-id="tags-basic" v-model="$v.additional_details.tags.$model"></b-form-tags>
                                    </b-form-group>
                                    <b-form-group label="Code.org share Link (Eg:-https://studio.code.org/projects/applab/XYZ123ABC....)" class="text-left" v-if="additional_details.kits.filter(a=>a.code.includes('codeOrg')).length">
                                        <b-form-input v-model="$v.codeOrg.$model" required></b-form-input>
                                        <div class="text-danger" v-if="$v.codeOrg.$error">
                                            <small v-if="!$v.codeOrg.required">
                                                * Required Field
                                            </small>
                                        </div>
                                    </b-form-group>
                                    <b-form-group label="MIT exported file (.aia)" class="text-left" v-if="additional_details.kits.filter(a=>a.code.includes('MIT')).length">
                                        <input type='file' required @change="uploadAia" >
                                    </b-form-group>
                                </div>
                            </b-col>
                        </b-row>
                    </section>

                    <footer class="modal-footer flex-nowrap">
                        <button
                            type="button"
                            class="btn-secondary btn"
                            style="width: 50%"
                            :class="{ 'btn-disabled': $v.uploads.$invalid }"
                            :disabled="$v.uploads.$invalid"
                            @click="back">
                            Back
                        </button>
                        <b-overlay
                            :show="processing"
                            class="d-inline-block"
                            style="width: 50%"
                            spinner-small
                            >
                            <button
                                :class="{ 'next-btn-disabled': btnDisabled || (step == 3 ? (additional_details.kits.length > 1 ? ((additional_details.kits.filter(a=>a.code.includes('codeOrg')).length || additional_details.kits.filter(a=>a.code.includes('MIT')).length) ? true : false) : false) : false) }"
                                type="submit"
                                class="btn-orangy"
                                style="width: 100%"
                                :disabled="btnDisabled || (step == 3 ? (additional_details.kits.length > 1 ? ((additional_details.kits.filter(a=>a.code.includes('codeOrg')).length || additional_details.kits.filter(a=>a.code.includes('MIT')).length) ? true : false) : false) : false)"
                                @keyup.enter="next"
                                aria-label="Close modal">
                                <span v-if="step < 3">
                                    Next
                                </span>
                                <span v-else>
                                    Upload
                                </span>
                            </button>
                        </b-overlay>
                    </footer>
                    
                    <b-modal id="success-project-upload" size="lg" centered hide-header hide-footer no-close-on-backdrop>
                        <div class="success-container">
                            <div class="cross" @click="$bvModal.hide('success-project-upload'); $router.go()">
                                <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel">
                            </div>
                            <div class="title">Your project has been submitted for approval to our community managers.</div>
                            <div class="content">Check the 'My Projects' page in <span style="font-weight: 600">48 hours</span> to see your uploaded project.</div>
                        </div>
                    </b-modal>

                </div>
            </b-form>
        </div>
    </transition>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
$orange-color: #DF711B;

@media only screen and (min-width: 1025px) {
    .modal {
        width: 70vw;
        height: 74.6vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
    .scrollbar-primary::-webkit-scrollbar {
        width: 10px;
        background-color: #F5F5F5;
    }
    .scrollbar-primary::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #9c9c9c; 
    }
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
}
.form-control {
    padding-top: 0.75rem;
    padding-right: 0.75rem;
    padding-bottom: 0.6rem;
    padding-left: 0.75rem;
}
.orange-button {
  font-family: Roboto !important;
  outline: 0 !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  background: #f36f2e !important;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%) !important;
  border: 1px solid #f36f2e !important;
  box-sizing: border-box !important;
  border-radius: 30px !important;
  padding: 0.5rem 1rem !important;
  color: white !important;
}
.modal {
    background: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 9px;
}

.custom-modal-header,
.modal-footer {
    padding: 15px 20px;
    display: flex;
}

.custom-modal-header {
    position: relative;
    border-bottom: 1px solid #cfbcbcd3;
    font-size: 1.5rem;
    color: black;
    font-weight: 600;
    justify-content: space-between;
    align-items: center;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    align-items: center;
    padding: 10px;
    justify-content: center;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: auto;
    overflow-x:hidden;
}
.row {
    margin: 0;
}
.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 30px;
    padding: 10px 20px;
    cursor: pointer;
    font-weight: bold;
    color: rgb(97, 89, 89);
    background: transparent;
}
.btn-orangy {
    background: $orange-color;
    border: 1px solid $orange-color;
}
.btn-orangy, .btn-secondary {
    color: white;
    font-weight: 600;
    padding: .7rem 4rem;
    border-radius: 25px;
}
.btn-secondary {
    color: $orange-color;
    background-color: white;
    border-color: $orange-color;
    box-shadow: none;
}
.btn-orangy:focus {
    outline:none;
}
.btn-disabled {
    background-color: #fff !important;
    cursor:not-allowed;
    border: 1px solid #cecece;
    color: rgb(97, 89, 89);
}
.next-btn-disabled {
    background-color: #cecece !important;
    cursor:not-allowed;
    border: 1px solid #cecece;
    color: #fff;
}
@media (min-width: 576px) {
    .card-columns{
        column-gap: 0.5rem;
    }
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}

label {
    width: 100%;
    margin: 0;
    height: 50vh;
    border: 2px dashed $orange-color;
    border-radius: 10px;
    cursor: pointer;
    background-color: white;
    position: relative;
    text-align: center;
    display: block;
    & .label-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.2rem;
        font-weight: 600;
        color: rgb(146, 140, 140);
        width: 100%;
        text-align: center;
        & .row {
            & .col-3:not(:last-child) {
                border-right: 1px solid #ababab;
            }
        }
    }
}
label.add-more {
    height: 18vh;
    margin-bottom: 2rem;
}
ul.progressbar {
    padding-left: 0;
}

.progressbar {
    counter-reset: step;
}
.progressbar li {
    list-style-type: none;
    width: 100px;
    float: left;
    font-size: 12px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: #7d7d7d;
}
.progressbar li:before {
    width: 30px;
    height: 30px;
    content: counter(step);
    counter-increment: step;
    line-height: 30px;
    border: 2px solid #7d7d7d;
    display: block;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 10px auto;
    border-radius: 50%;
    background-color: white;

}
.progressbar li.active:before {
    font-family: "Font Awesome 5 Free";
    content: "\f00c";
    background-color: #9BC157;
    color: #fff!important;
}
.progressbar li:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background-color: #7d7d7d;
    top: 15px;
    left: -50%;
    z-index: -1;
}
.progressbar li:first-child:after {
    content: none;
}
.progressbar li.active {
    color: #9BC157;
}
.progressbar li.active:before {
    border-color: #9BC157;
    color: #9BC157;
}
.progressbar li.active + li:after {
    background-color: #9BC157;
}
.upload-overlay {
    position: absolute;
    top: 0%;
    right: 0%;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 5px 5px 0 5px;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    cursor: pointer;
}

.progress-bar-mobile {
    display: none;
}

@media only screen and (max-width: 600px) {
    .progressbar li {
        width: 33.33%;
    }

    .progress-bar-mobile {
        display: block;
    }

    .progress-bar-desktop {
        display: none;
    }
    .upload-thumbnail-label {
        height: 35vh !important;
    }
    .progressbar li.active:before {
        background-image: url("https://images.avishkaar.cc/misc/competitions/tick-icon-white.png");
        background-position: center;
        background-size: 40%;
        background-repeat: no-repeat;
        content: "";
        font-size: 1.4rem;
    }
}

@media only screen and (min-width: 1000px) {
    .deleteButtonIcon {
        display: none;
    }
    .deleteButton:hover .deleteButtonIcon {
        display: inherit;
    }
}
</style>
<style lang="scss">
#success-project-upload .success-container {
    background-image: url("https://images.avishkaar.cc/misc/projects/success-upload-project.png"), linear-gradient(rgb(199, 248, 255, 1),rgb(199, 248, 255, 0));
    background-position: center 10%;
    background-repeat: no-repeat;
    height: 80vh;
    padding: 2rem;
    .cross{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
    }
    .title{
        font-family: Poppins;
        font-weight: 600;
        font-size: 1.5rem;
        text-align: center;
        color: #000000;
        margin: 45vh 0 0 0;
    }
    .content{
        font-family: Roboto;
        font-weight: 500;
        font-size: 1rem;
        text-align: center;
        color: #000000;
        margin: 1rem 0 0 0;
    }
}
@media only screen and (max-width: 700px) {
    #success-project-upload { padding: 0 !important}
    #success-project-upload .modal-dialog {
        margin: 0;
        max-width: none;
    }
    #success-project-upload .success-container {
      height: 99.7vh;
      padding: 0.5rem;
      .cross{
        padding: 1rem;
    }
      .title{
        font-size: 1.25rem;
        margin: 55vh 0 0 0;
      }
      .content{
        font-size: 0.875rem;
        margin: 1rem 0 0 0;
      }
    }
}
</style>